<section class="main">
    <h1>invoices</h1>
    <section class="sup_main">
        <h2>Unit Name : {{unit_name}}</h2>
        <hr>
        <section>
            <mat-tab-group>
                <mat-tab label="Utilities">
                    <section class="tableUnit table-responsive mt-3">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">Section</th>
                                    <th scope="col">Ammount</th>
                                    <th scope="col">Consumed</th>
                                    <th scope="col">Created at</th>
                                    <th scope="col">Updated on</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of utilty_arr ; let i = index">
                                    <td >
                                   {{item.purchase_name}}
                                    </td>
                                    <td>
                                        {{item.section}}
                                    </td>
                                    <td>
                                      {{item.ammount}}
                                    </td>
                                    <td>
                                        {{item.consumed}}
                                    </td>
                                    <td>
                                       {{item.created_at}}
                                    </td>
                                    <td>
                                        {{item.updated_on}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <h3 *ngIf="utilty_arr.length == 0">No Data Found</h3>
                    </section>
                </mat-tab>

                <mat-tab label="Services">
                        <section class="tableUnit table-responsive mt-3">
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">Name</th>
                                            <th scope="col">Ammount</th>
                                            <th scope="col">Created at</th>
                                            <th scope="col">Updated on</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of service_arr ; let i = index">
                                            <td >
                                           {{item.purchase_name}}
                                            </td>
                                            <td>
                                              {{item.ammount}}
                                            </td>
                                           
                                            <td>
                                               {{item.created_at}}
                                            </td>
                                            <td>
                                                {{item.updated_on}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <h3 *ngIf="service_arr.length == 0">No Data Found</h3>
                            </section>
                </mat-tab>

                <mat-tab label="Others">
                        <section class="tableUnit table-responsive mt-3">
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">Name</th>
                                            <th scope="col">Ammount</th>
                                          
                                            <th scope="col">Created at</th>
                                            <th scope="col">Updated on</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of other ; let i = index">
                                            <td >
                                           {{item.purchase_name}}
                                            </td>
                                            <td>
                                              {{item.ammount}}
                                            </td>
                                           
                                            <td>
                                               {{item.created_at}}
                                            </td>
                                            <td>
                                                {{item.updated_on}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <h3 *ngIf="other.length == 0">No Data Found</h3>
                            </section>
                </mat-tab>
            </mat-tab-group>
        </section>
    </section>
</section>